import {
  BaseGetTradeExtraInfoDataRequest,
  GetTradeExtraInfoOrdersGraphRequest,
  PrecisionConfig,
} from "@shared/types";
import { createSelector } from "reselect";
import { get } from "lodash";
import { SkipToken } from "@reduxjs/toolkit/query";
import { sharedLib } from "@shared/services/shared.service";

export const selectTradeExtraInfoOrdersGraphPriceCoin = (
  args: GetTradeExtraInfoOrdersGraphRequest
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoOrdersGraph.select(
      args
    ),
    ({ data }) => data?.data?.price_coin
  );
export const selectTradeExtraInfoOrdersGraphPrecision = (
  args: GetTradeExtraInfoOrdersGraphRequest | SkipToken
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoOrdersGraph.select(
      args
    ),
    ({ data }): PrecisionConfig | undefined => data?.precision
  );
export const selectTradeExtraInfoGeneralData = (
  args: BaseGetTradeExtraInfoDataRequest | SkipToken
) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getTradeExtraInfoGeneral.select(args),
    (tradeExtraInfoData) => get(tradeExtraInfoData, ["data", "data", "general"])
  );
